import { IdentificationCardIcon } from "@phosphor-icons/react/dist/csr/IdentificationCard";
import { Button } from "@volca/ui/components/ui/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";

interface RosterFilterEmptyStateProps {
  search: string;
  activeFilterCount: number;
  onClear: () => void;
}

export const RosterFilterEmptyState = ({
  search,
  activeFilterCount,
  onClear,
}: RosterFilterEmptyStateProps) => {
  const trimmedSearch = search.trim();
  const searching = trimmedSearch.length > 0;
  const content =
    searching && activeFilterCount > 0
      ? {
          title: "No people match your search and filters",
          hint: "Try a different name, or widen one of the field filters.",
          action: "Clear search and filters",
        }
      : searching
        ? {
            title: `No people match “${trimmedSearch}”`,
            hint: "Search matches a person's name or their ServiceTitan ID.",
            action: "Clear search",
          }
        : {
            title: "No people match these filters",
            hint: "The filters overlap on nobody. Widen or remove one.",
            action:
              activeFilterCount === 1 ? "Clear the filter" : "Clear filters",
          };

  return (
    <Empty className={emptyStateVariants({ layout: "workspace" })}>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <IdentificationCardIcon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{content.title}</EmptyTitle>
        <EmptyDescription>{content.hint}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button type="button" size="sm" variant="secondary" onClick={onClear}>
          {content.action}
        </Button>
      </EmptyContent>
    </Empty>
  );
};
